import { flatten, groupBy } from 'lodash';
import { nodesForExclusion } from '../../../const';
import { Design } from '../../../types';

export interface DuplicateIdItem {
  id: string;
  moduleId: string;
  moduleName: string;
  name: string;
  type: DuplicateIdItemType;
}

export enum DuplicateIdItemType {
  node = 'Node'
}

/** Get items from the application with the same ID. */
export function getDuplicateIdItems(application: Design): DuplicateIdItem[] {
  // Get all module items to check for duplicate IDs on.
  const allItems = flatten(application.components.modules.map((moduleItem) => {
    return moduleItem.versions[1].flow.nodes.filter((node) => {
      return !nodesForExclusion.has(node._class);
    }).map(({ id, name }): DuplicateIdItem => {
      return {
        id,
        moduleId: moduleItem.id,
        moduleName: moduleItem.name,
        name,
        type: DuplicateIdItemType.node
      };
    });
  }));

  return flatten(Object.entries(groupBy(allItems, 'id')).filter(([_id, idItems]) => {
    return idItems.length > 1;
  }).map(([_id, idItems]) => {
    return idItems;
  }));
}
